import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { Router } from './Router';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Router />
  );
}

export default App;
